// extracted by mini-css-extract-plugin
export default {"banner":"EyebrowBanner-module__banner--fX7Dr","visual":"EyebrowBanner-module__visual--rImjt","heading":"EyebrowBanner-module__heading--Yo96O"};